<mat-tab-group>
  <mat-tab
    *ngFor="let tab of field.fieldGroup; let i = index; let last = last"
    [label]="tab.templateOptions?.label || ''">
    <div class="mt-3">
      <formly-field [field]="tab"></formly-field>
    </div>
  </mat-tab>
</mat-tab-group>
